// ua-helper.js
export async function getUAData() {
    const ua = navigator.userAgent || "";
    const uaData = navigator.userAgentData;

    let browserName = "Unknown";
    let deviceModel = "Unknown";
    let deviceType = "Desktop";
    let deviceVendor = "Unknown";
    let osName = "Unknown";
    let osVersion = "Unknown";

    // --- 1. Use User-Agent Client Hints if available ---
    if (uaData) {
        const highEntropy = await uaData.getHighEntropyValues([
            "platform",
            "platformVersion",
            "architecture",
            "model",
            "uaFullVersion"
        ]);

        osName = highEntropy.platform ? highEntropy.platform : "Unknown";
        osVersion = highEntropy.platformVersion ? highEntropy.platformVersion : "Unknown";
        deviceModel = highEntropy.model ? highEntropy.model : "Unknown";

        if (uaData.brands && uaData.brands.length > 0) {
            browserName = uaData.brands[0].brand;
        } else {
            browserName = "Unknown";
        }

        deviceType = uaData.mobile ? "Mobile" : "Desktop";
    } else {
        // --- 2. Fallback to parsing old userAgent string ---
        if (/mobile/i.test(ua)) deviceType = "Mobile";
        if (/tablet/i.test(ua)) deviceType = "Tablet";

        if (ua.indexOf("Windows") !== -1) osName = "Windows";
        else if (ua.indexOf("Mac") !== -1) osName = "MacOS";
        else if (ua.indexOf("Linux") !== -1) osName = "Linux";
        else if (/Android/.test(ua)) osName = "Android";
        else if (/iPhone|iPad|iPod/.test(ua)) osName = "iOS";

        const browserMatch = ua.match(/(Chrome|Firefox|Safari|Edge)\/([\d.]+)/);
        if (browserMatch) browserName = browserMatch[1] + " " + browserMatch[2];
    }

    // --- 3. Simple fingerprint ---
    const fingerprintSource = [
        ua,
        osName,
        osVersion,
        browserName,
        deviceType,
        deviceModel,
        screen.width + "x" + screen.height,
        Intl.DateTimeFormat().resolvedOptions().timeZone
    ].join("|");

    const fingerprint = await sha256(fingerprintSource);

    return {
        browser: { name: browserName },
        device: { model: deviceModel, type: deviceType, vendor: deviceVendor },
        os: { name: osName, version: osVersion },
        fingerprint
    };
}

// --- helper: SHA-256 hashing ---
async function sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(function(b) { return b.toString(16).padStart(2, "0"); }).join("");
}
